import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

export interface PhysiologicalParamsResponse {
  phenologicalStages: string[]
  colorScales: string[]
}

export async function getPhysiologicalParams(
  culture: 'soybean' | 'corn',
  config?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<PhysiologicalParamsResponse>(
    apiRoutes.getPhysiologicalParams(culture),
    config,
  )
  return data
}
